<template>
  <div class="quiz__step"  id="step-9">
    <div class="quiz__tab-item-wrap">
      <div class="quiz__aside">

        <btn-back
            :text="translate.masterBackText"
            @backToStep="backToStep"
        />

        <div class="loader-wrap" v-if="loader > 0">
          <div class="loader" ></div>
        </div>

        <div class="quiz-checks checks-for-material" v-for="material in materials" :key="material.id+'mq8'" data-material="{{ material.value }}" v-show="materialParam == material.value" >

          <div v-for="variant in getVariants(material.variants, 'eight')" :key="variant.id">
            <label class="radio" v-if="checkCargoType(variant.value)" :ref="'c_'+variant.id" :class="variant.value == cargoParam ? 'checked' : ''">
              <input type="radio" v-model="cargoParam" name="step-9" :value="variant.value" class="param-{{ variant.id }}" />
              <div class="radio__text">{{ variant.name }}</div>
            </label>
          </div>

        </div>


      </div>
      <div class="quiz__content">
        <div v-if="texts && texts['cargoText'+lang]" v-html="texts['cargoText'+lang]">
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import BtnBack from "../BtnBack.vue";
import {default as axios} from "axios";
import qs from "querystring";
export default {
  name: "CargoComponent",
  components: {BtnBack},
  props: ['translate', 'materials', 'materialParam', 'letterType', 'stepEight', 'texts', 'lang', 'marking', 'step'],
  data(){
    return {
      loader: 0
    }
  },
  computed:{
    cargoParam:{
        get(){
            return this.stepEight;
        },
        set(newVal){
          this.$emit('changeCargoParam', newVal);


        }
    }
  },

  methods: {
    backToStep() {
      this.$emit('backToStep')
    },
    getVariants(variants, name) {
      return (variants.filter(element => element.step == name));
    },

    //варианты Выбора типа груза
    checkCargoType(val){

      //Без груза, Для ЧЭ "Т", "С", "Н", "К"
      if(val === 0 || val === '0'){
        if(!(this.letterType == 'С' || this.letterType == 'Т' || this.letterType == 'К' || this.letterType == 'Н')){
          return false;
        }
      }

      //Груз из стали 45 с резиновыми уплотнениями, для ЧЭ «Г», «В», «Д»
      if(val == 1){
        if(!(this.letterType == 'Г' || this.letterType == 'В' || this.letterType == 'Д')){
          return false;
        }
      }

      //Груз из стали 12Х18Н10Т с резиновыми уплотнениями, для ЧЭ «В»
      if(val == 2){
        if(!(this.letterType == 'В')){
          return false;
        }
      }

      //Груз из стали 06ХН28МДТ с фторопластовыми уплотнениями, для ЧЭ «В»
      if(val == 3){
        if(!(this.letterType == 'В')){
          return false;
        }
      }

      //Груз из стали 12Х18Н10Т с фторопластовыми уплотнениями, для ЧЭ видов «В», «Д»
      if(val == 4){
        if(!(this.letterType == 'В' || this.letterType == 'Д')){
          return false;
        }
      }

      return true;
    },

    findMarking(cargoParam, key) {

        let name = (this.marking.numberType ? (this.marking.letterType ? this.marking.numberType + this.marking.letterType : '') : '')
            + ('000' + this.marking.longParam).slice(-3)
            + '-' + this.marking.threadParam
            + this.marking.voltageParam
            + this.marking.bodyParam
            + this.marking.bracingParam
            + cargoParam;

        this.loader++;
        axios
            .post('/directrequest/catalog/master/find-marking.json/', qs.stringify({
              marking: name
            }))
            .then((response) => {
              if(!Boolean(response.data) && this.$refs[key]){
                $(this.$refs[key][0]).addClass('disable-param');
                $(this.$refs[key][0]).find('input').prop( "disabled", true );
              }
              this.loader--;
            })
            .catch((error) => {
              this.loader--;
              console.log(error);
            });

    }
  },
  watch: {

    step() {
      if (this.step == 9) {
        for (var material in this.materials) {

          let v = this.getVariants(this.materials[material].variants, 'eight');

          for (var variant in v) {
            this.findMarking(v[variant].value, 'c_'+v[variant].id);
          }

        }
      }
      if(this.step < 9){

        for (var mat in this.materials) {

          let v = this.getVariants(this.materials[mat].variants, 'eight');

          for (var vari in v) {
            if (this.$refs['c_' + v[vari].id]){
              $(this.$refs['c_' + v[vari].id][0]).removeClass('disable-param');
              $('#step-9 label').removeClass('disable-param');
              $(this.$refs['c_' + v[vari].id][0]).find('input').prop("disabled", false);
            }
          }

        }
      }
    }
  }
}
</script>

<style scoped>

</style>